






import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
  import * as d3 from "d3";
  import moment from "moment";
  import { RgbColor } from "@/shared/types";
  import { formatCurrency } from "@/shared/currency";
  import _ from "lodash";
  import { GChart } from "vue-google-charts";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    GChart
  }
})
export default class DeductibleTrackerBarChart extends Vue {
  themeStore = useThemeStore();

  @Prop()
  width: number;

  @Prop()
  height: number;

  @Prop()
  margin: number;

  @Prop()
  contributionAmount: number;

  @Prop()
  maxAmount: number;

  @Prop()
  label: string;

  formatCurrency = formatCurrency;

  emptyColor = "#E6EAEE";

  get getChartOptions () {
    return {
      title: this.spentLabelAmount,
      titleTextStyle: {
        color: this.themeStore.tertiaryColor,
        fontSize: 12,
        bold: true
      },
      colors: [this.themeStore.primaryColor, this.emptyColor],
      legend: {
        position: "none"
      },
      vAxis: {
        baselineColor: "#000",
        ticks: [0],
        textPosition: "none"
      },
      hAxis: {
        textStyle: {
          color: "#000",
          fontSize: 12,
          bold: false
        }
      },
      isStacked: "percent",
      width: this.width,
      heigh: this.height,
      bar: { groupWidth: "80%" },
      enableInteractivity: false,
    };
  }

  get getLabel () {
    return `${this.label} \n ${formatCurrency(this.maxAmount)}`;
  }

  get remainingContributionAmount () {
    return (this.maxAmount - this.contributionAmount);
  }

  get spentLabelAmount () {
    return `Spent ${formatCurrency(this.contributionAmount)}`;
  }

  get chartData () {
    return [
      ["Item", "Contribution", "Max"],
      [ this.getLabel, this.contributionAmount, this.remainingContributionAmount],
    ];
  }
}
